import { render, staticRenderFns } from "./topmenu.vue?vue&type=template&id=173dce94&"
import script from "./topmenu.vue?vue&type=script&lang=js&"
export * from "./topmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173dce94')) {
      api.createRecord('173dce94', component.options)
    } else {
      api.reload('173dce94', component.options)
    }
    module.hot.accept("./topmenu.vue?vue&type=template&id=173dce94&", function () {
      api.rerender('173dce94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Header/topmenu.vue"
export default component.exports